import { useRef, useState } from "react";
import { ImagePlus, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "../lib/api";

export const CoverControls = ({ profile, setProfile, setUser }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    if (!file.type.startsWith("image")) return toast.error("Cover must be an image");
    setBusy(true);
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/auth/cover", fd, { headers: { "Content-Type": "multipart/form-data" } });
      setProfile((p) => ({ ...p, cover_url: data.cover_url }));
      setUser?.(data.user);
      toast.success("Cover photo updated");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Upload failed"); }
    setBusy(false);
    if (ref.current) ref.current.value = "";
  };

  const remove = async () => {
    setBusy(true);
    try {
      await api.delete("/auth/cover");
      setProfile((p) => ({ ...p, cover_url: null }));
      toast.success("Cover photo removed");
    } catch { toast.error("Could not remove cover"); }
    setBusy(false);
  };

  return (
    <div className="absolute top-3 right-3 z-10 flex gap-2">
      <button data-testid="cover-change-btn" onClick={() => ref.current?.click()} disabled={busy}
        className="flex items-center gap-1.5 bg-black/55 backdrop-blur-md border border-white/15 text-white text-xs font-semibold px-3 py-2 rounded-full hover:bg-black/75 transition-colors disabled:opacity-50">
        {busy ? <Loader2 size={13} className="animate-spin" /> : <ImagePlus size={13} />} {profile.cover_url ? "Change cover" : "Add cover"}
      </button>
      {profile.cover_url && (
        <button data-testid="cover-remove-btn" onClick={remove} disabled={busy} title="Remove cover"
          className="grid place-items-center w-8 h-8 bg-black/55 backdrop-blur-md border border-white/15 text-white rounded-full hover:text-[#FF2A5F] transition-colors disabled:opacity-50">
          <Trash2 size={13} />
        </button>
      )}
      <input ref={ref} type="file" accept="image/*" className="hidden" data-testid="cover-file-input" onChange={(e) => upload(e.target.files[0])} />
    </div>
  );
};
